import { MouseEvent } from 'react';
import { useTranslation } from 'react-i18next';
import { AlertTriangle } from 'lucide-react';
import { cn } from '@utils/cn';
import { ConflictLinkProps } from './types';

export const ConflictLink = ({ count, onClick, compact }: ConflictLinkProps) => {
  const { t } = useTranslation('app');

  return (
    <span
      role="button"
      tabIndex={0}
      aria-label={t('scheduling.phone.conflicts', { count })}
      onClick={(e: MouseEvent) => {
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      onKeyDown={(e) => {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        e.preventDefault();
        e.stopPropagation();
        onClick();
      }}
      className={cn(
        'inline-flex min-h-8 shrink-0 cursor-pointer items-center gap-1 text-[13px] font-semibold text-warning-500 underline-offset-2 active:underline',
        compact && '-my-2 min-h-9 min-w-9 justify-center px-1 text-xs',
      )}>
      <AlertTriangle className="h-3.5 w-3.5 shrink-0" />
      {count > 1 && count}
    </span>
  );
};
